import { render, staticRenderFns } from "./TripShuttle.vue?vue&type=template&id=f66c0bf0"
import script from "./TripShuttle.vue?vue&type=script&lang=js"
export * from "./TripShuttle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports